var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6 9L12 15L18 9","stroke":"#1D3F91","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ChevronDown.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
